import { useProductsContext } from "../../hooks/useProductsContext";
import "./newProduct.css";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";
import {useState} from "react"
import { HashLoader } from 'react-spinners';


export default function NewProduct() {
 
  const {dispatch,name,setName, price, setPrice,
    color, setColor, size, setSize,stock, setStock,
    error, setError,emptyFields, setEmptyFields,
   update, setUpdate,url, setUrl,category, setCategory} = useProductsContext()

   const [loading, setLoading] = useState(false);
   const [popupMessage, setPopupMessage] = useState("");

  const [image, setImage] = useState();


  // Initialize colors state with an empty string

  const handleColorChange = (index, value) => {
    const updatedColors = [...color]; // Create a copy of the colors array
    updatedColors[index] = value; // Update the color value at the specified index
    setColor(updatedColors); // Update the colors state
  };

  const handleAddColor = () => {
    setColor([...color, '']);
   
  };


  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const imageRef = ref(storage, `products/${image.name}`);
    await uploadBytes(imageRef, image).then(() => {
      getDownloadURL(imageRef).then( (downloadURL) => {
        setUrl(downloadURL);
        console.log("URL", url);
        setLoading(false)
      })
      
      })
  
    const product = {name, price, color,size,stock,url,category}

        const response  =  await fetch('https://fashionforwardd.azurewebsites.net/api/products', {
            method: 'POST',
            body: JSON.stringify(product),
           headers: {"Content-Type": "application/json",
   
          }})
        const json = await response.json()

        if(!response.ok) {
         
            setError(json.error)
            setEmptyFields(json.emptyFields)
            setLoading(false)
            console.log(emptyFields)
            setPopupMessage("Failed to add product. Please try again.");

           
        }
        if(response.ok) {
      
      
          setName('')
          setPrice('')
          setColor('')
          setSize('')
          setStock('')
          setUrl('')
          setCategory('')
        //  inputFile.value = null;
          setImage(null)
          setError(null)
          setEmptyFields([])
          setLoading(false)
          console.log("New product added", json)
          dispatch({type:'CREATE_PRODUCT',payload:json})
          setPopupMessage("Product added successfully!");
         
    }
    setTimeout(() => {
      setPopupMessage(""); // Clear the popup message after 2 seconds
    }, 2500);
    
  
  }

  return (

   
    <div className="newProduct">
  
    <HashLoader loading={loading} color="#00aaff" size={50}
    cssOverride={{
     display: "block",
      margin: "20% auto",

   }} />
 
   {!loading && 
    <>
    {popupMessage && (
  <div className="popup">
    <p>{popupMessage}</p>
  </div>
)}
   <h1 className="addProductTitle">New Product</h1>
      <form className="addProductForm" onSubmit={handleSubmit}>
        <div className="addProductItem">
          <label>Image</label>
          <input type="file" id="file" onChange={(e)=>{setImage(e.target.files[0])}} required/>
        </div>
       
        <div className="addProductItem">
          <label>Name</label>
          <input type="text" placeholder="Product Name"
          value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="addProductItem">
          <label>Price</label>
          <input type="number" placeholder="Product price" 
          value={price} onChange={(e) => setPrice(e.target.value)} required />
        </div>
        <div className="addProductItem">
        <label>Colors</label>
       
      {color && color.map((color, index) => (
        <input
          key={index}
          type="text"
          placeholder="Product color"
          value={color}
          id="colors"
          required
          onChange={(e) => handleColorChange(index, e.target.value)}
        />
      ))}
 
      <button type="button" onClick={handleAddColor}>Add more color</button>

         
        </div>
        <div className="addProductItem">
          <label>Size</label>
          <input type="text" placeholder="Product size" 
          value={size} onChange={(e) => setSize(e.target.value)} required />
        </div>
        <div className="addProductItem">
          <label>Stock</label>
          <input type="number" placeholder="Remaining stock" 
          value={stock} onChange={(e) => setStock(e.target.value)}  required/>
        </div>
        <div className="addProductItem">
          <label>Category</label>
          <select name="category" id="category" onChange={(e) => setCategory(e.target.value)} value={category} required>
            <option value="">---</option>
            <option value="men">Men</option>
            <option value="women">Women</option>
            <option value="accessories">Accessories</option>
          </select>
        </div>
        <button className="addProductButton" disabled={loading}> {loading ? "Loading..." : "Add Product"}</button>
      
      </form>
    </> } 
    </div>
     

  );
}
